module.exports = __webpack_public_path__ + "static/img/pic6.7ffd0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic6.png
// module id = A0cA
// module chunks = 0